import { AuthService } from './authService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

/**
 * Module access flags matching the backend ModuleAccessDto.
 * Determines which modules are visible in the operator dashboard.
 */
export interface ModuleAccess {
    // Legacy Profile fields
    pickListActive: boolean;
    goodsReceptionActive: boolean;
    packingActive: boolean;
    intRelocationActive: boolean;

    // New settings (from ProfileSetting/SystemSetting)
    inventoryCountingActive: boolean;
    inventoryCorrectionActive: boolean;
    warehouseTransferActive: boolean;
    locationMaintenanceActive: boolean;
    directOrderActive: boolean;
}

/** Default module access - all modules visible (used as fallback) */
export const DEFAULT_MODULE_ACCESS: ModuleAccess = {
    pickListActive: true,
    goodsReceptionActive: true,
    packingActive: true,
    intRelocationActive: true,
    inventoryCountingActive: true,
    inventoryCorrectionActive: true,
    warehouseTransferActive: true,
    locationMaintenanceActive: true,
    directOrderActive: false,
};

function getCompanyNo(): string {
    const token = AuthService.getToken();
    if (!token) return '';
    try {
        const payload = JSON.parse(
            decodeURIComponent(
                atob(token.split('.')[1])
                    .split('')
                    .map(char => `%${('00' + char.charCodeAt(0).toString(16)).slice(-2)}`)
                    .join('')
            )
        );
        return payload.CompanyNo || '';
    } catch {
        return '';
    }
}

class ModuleAccessService {
    /**
     * Get module access flags for the current operator.
     */
    async getModuleAccess(): Promise<ModuleAccess> {
        try {
            const companyNo = getCompanyNo();
            if (!companyNo) return DEFAULT_MODULE_ACCESS;

            const response = await AuthService.authenticatedGet(
                `${API_BASE_URL}/${companyNo}/ModuleAccess`
            );

            if (!response.ok) {
                console.warn('Failed to load module access, using defaults');
                return DEFAULT_MODULE_ACCESS;
            }

            return await response.json();
        } catch (error) {
            console.warn('Error loading module access, using defaults:', error);
            return DEFAULT_MODULE_ACCESS;
        }
    }
}

export const moduleAccessService = new ModuleAccessService();
